/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Entra_TitleInputs */



/**
* | output |
* | --- |
* | "Microsoft Entra ID (Azure AD)" |
*
* @param {Scim_Setup_Entra_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_entra_title = /** @type {((inputs?: Scim_Setup_Entra_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Entra_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Microsoft Entra ID (Azure AD)")
	return /** @type {LocalizedString} */ ("Microsoft Entra ID (Azure AD)")
});